//? ESLint is disabled so that the constants remain on a single line.
/* eslint-disable */

export const ACCOUNT_CONFIGURATION_PATH = "/app/configuration/accounts/list/:id";
export const ACCOUNT_LIST_PATH = "/app/configuration/accounts/list";
export const ACCOUNT_PATH = "/app/configuration/accounts";

export const APP_PATH = "/app";

export const CONFIGURATION_PATH = "/app/configuration";

export const EXCHANGE_SHOW_PATH = "/app/returns/exchanges/:id";
export const EXCHANGE_PATH = "/app/returns/exchanges";
export const EXCHANGE_CREATION_PATH = "/app/returns/exchanges/new";

export const SCHEDULED_ACTION_PATH = "/scheduled_action";

export const RETURN = "/app/returns";
export const RETURN_LIST = "/app/returns/list";

export const ORDER_PATH = "/app/orders";

export const HOME_PATH = "/app/home";

export const SESSION_RECOVERY_PASSWORD_PATH = "/session/recovery_password";
export const SESSION_LOGIN_PATH = "/session/signin";

export const USER_LIST_PATH = "/app/users";

export const WAREHOUSE_EDIT = "/app/warehouses/:id/edit";
export const WAREHOUSE_LIST_PATH = "/app/warehouses";
export const WAREHOUSE_NEW = "/app/warehouses/new";
export const WAREHOUSE_SHOW = "/app/warehouses/:id";

//? This route map is used to populate the section names in the breadcrumbs.
export const ROUTES_MAP = {
  //? accounts
  [ACCOUNT_PATH]: "Cuentas",
  [ACCOUNT_LIST_PATH]: "Listado de cuentas",
  //? home
  [APP_PATH]: "Inicio",
  //? cofigurations
  [CONFIGURATION_PATH]: "Configuración",
  //? exchanges
  [EXCHANGE_PATH]: "Cambios",
  [EXCHANGE_CREATION_PATH]: "Nuevo cambio",
  //? returns
  [RETURN]: "Retornos",
  //? users
  [USER_LIST_PATH]: "Usuario",
  //? Warehouses
  [WAREHOUSE_LIST_PATH]: "Depósitos",
  [WAREHOUSE_NEW]: "Nuevo",
  [WAREHOUSE_EDIT]: "Editar",
  [WAREHOUSE_SHOW]: "Show",
};

